angular.module("vgresiduos").controller("EditAuditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton(
				$rootScope,
				`organizacao/fornecedores/${$stateParams.supplierCode}/auditoria/${$stateParams.auditId}`,
				getQueries()
			);
		};

		function getQueries() {
			const queries = [{ key: "tab", value: $stateParams.tab }];
			if ($stateParams.isSupplierView) {
				queries.push({ key: "isSupplierView", value: $stateParams.isSupplierView });
			}
			return queries;
		}
	}
]);
